import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

export function StoreSelect() {
    const [store, setStore] = React.useState('Stamford');

    const handleChange = (event: SelectChangeEvent) => {
        setStore(event.target.value as string);
    };

    return (
        <Box
            sx={{
                minWidth: 120,
                '& .MuiInputBase-input': { backgroundColor: '#FFF' },
            }}
        >
            <FormControl fullWidth>
                <InputLabel
                    id="demo-simple-select-label"
                    sx={{
                        color: '#000',
                    }}
                >
                    Store
                </InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={store}
                    label="Store"
                    onChange={handleChange}
                >
                    <MenuItem value={'Stamford'}>
                        Stamford
                    </MenuItem>
                </Select>
            </FormControl>
        </Box>
    );
}
